import React, { SyntheticEvent } from 'react';
import { AppBar, Box, Button, makeStyles, Toolbar } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon from '@material-ui/icons/Delete';
import { Prompt } from 'react-router';

const useStyles = makeStyles((theme) => ({
	appBar: {
		top: 'auto',
		bottom: 0,
		display: 'flex',
		zIndex: theme.zIndex.drawer + 1
	},
	childrenContainer: {
		marginBottom: theme.spacing(10)
	},
	toolbar: {
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	deleteButton: {
		margin: theme.spacing(1),
		color: 'red'
	},
	submitButton: {
		margin: theme.spacing(1)
	}
}));

const EditorForm: React.FC<EditorFormProps> = (props) => {
	const { cancelText, children, onCancel, onSubmit, onDelete, saveDisabled, deleteText, submitText } = props;

	const classes = useStyles();

	return (
		<form id='editorForm' onSubmit={onSubmit}>
			<Box className={classes.childrenContainer}>{children}</Box>
			<AppBar position='fixed' color='primary' className={classes.appBar}>
				<Toolbar className={classes.toolbar}>
					<div />
					<div>
						{cancelText && (
							<Button aria-label='Cancel' onClick={onCancel} data-testid='editor-cancel'>
								{cancelText}
							</Button>
						)}
						{deleteText && (
							<Button data-dismiss='alert' aria-label='Delete' className={classes.deleteButton} onClick={onDelete} data-testid='editor-delete'>
								<DeleteIcon /> {deleteText}
							</Button>
						)}
						{submitText && (
							<Button
								className={classes.submitButton}
								size='medium'
								variant='contained'
								color='secondary'
								type='submit'
								disabled={saveDisabled}
								data-testid='editor-submit'>
								<SaveIcon /> {submitText}
							</Button>
						)}
					</div>
				</Toolbar>
			</AppBar>
			<Prompt when={!saveDisabled} message='You have unsaved changes, do you want to leave this page and discard these changes?' />
		</form>
	);
};

type EditorFormProps = {
	cancelText?: string;
	onCancel?: (event: SyntheticEvent) => void;
	onSubmit?: (event: SyntheticEvent) => Promise<unknown>;
	onDelete?: (event: SyntheticEvent) => Promise<unknown>;
	saveDisabled?: boolean;
	deleteText?: string;
	submitText?: string;
};

export default EditorForm;
